import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import Header, { NAV_LAYOUT_BREAKPOINT_PX } from './components/Header';
import Footer from './components/Footer';
import SkipLink from './components/SkipLink';
import Breadcrumbs from './components/Breadcrumbs';
import { LocaleProvider } from './context/LocaleContext';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Disclaimer from './pages/Disclaimer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import LegalNotice from './pages/LegalNotice';
import Construction from './pages/Construction';
import IndustrialProducts from './pages/IndustrialProducts';
import ElectricalProducts from './pages/ElectricalProducts';
import ChemicalProducts from './pages/ChemicalProducts';
import OtherProducts from './pages/OtherProducts';
import ExecutionGovernance from './pages/ExecutionGovernance';
import StrategicIntelligence from './pages/StrategicIntelligence';
import StrategicIntelligenceCategoryPage from './pages/StrategicIntelligenceCategoryPage';
import StrategicIntelligenceArticlePage from './pages/StrategicIntelligenceArticlePage';
// Dynamic Solutions pages
import SectionPage from './pages/solutions/SectionPage';
import SubsectionPage from './pages/solutions/SubsectionPage';

const MainContent = styled.main`
  padding-top: 80px;
  
  @media (max-width: ${NAV_LAYOUT_BREAKPOINT_PX - 1}px) {
    padding-top: 70px;
  }
`;

function AppContent() {
  return (
    <div className="App">
      <SkipLink />
      <Header />
      <MainContent role="main" id="main-content" tabIndex="-1">
        <Routes>
          {/* English routes (no prefix) */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/execution-governance" element={<ExecutionGovernance />} />
          <Route path="/strategic-intelligence" element={<StrategicIntelligence />} />
          <Route path="/strategic-intelligence/:categoryId/:articleId" element={<StrategicIntelligenceArticlePage />} />
          <Route path="/strategic-intelligence/:categoryId" element={<StrategicIntelligenceCategoryPage />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
          <Route path="/construction" element={<Construction />} />
          <Route path="/industrial-products" element={<IndustrialProducts />} />
          <Route path="/electrical-products" element={<ElectricalProducts />} />
          <Route path="/chemical-products" element={<ChemicalProducts />} />
          <Route path="/other-products" element={<OtherProducts />} />
          <Route path="/solutions/:sectionId/:subsectionId" element={<SubsectionPage />} />
          <Route path="/solutions/:sectionId" element={<SectionPage />} />
          {/* Chinese routes (/cn prefix) - same components, locale derived from URL */}
          <Route path="/cn" element={<Home />} />
          <Route path="/cn/services" element={<Services />} />
          <Route path="/cn/about" element={<About />} />
          <Route path="/cn/contact" element={<Contact />} />
          <Route path="/cn/execution-governance" element={<ExecutionGovernance />} />
          <Route path="/cn/strategic-intelligence" element={<StrategicIntelligence />} />
          <Route path="/cn/strategic-intelligence/:categoryId/:articleId" element={<StrategicIntelligenceArticlePage />} />
          <Route path="/cn/strategic-intelligence/:categoryId" element={<StrategicIntelligenceCategoryPage />} />
          <Route path="/cn/disclaimer" element={<Disclaimer />} />
          <Route path="/cn/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cn/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/cn/legal-notice" element={<LegalNotice />} />
          <Route path="/cn/construction" element={<Construction />} />
          <Route path="/cn/industrial-products" element={<IndustrialProducts />} />
          <Route path="/cn/electrical-products" element={<ElectricalProducts />} />
          <Route path="/cn/chemical-products" element={<ChemicalProducts />} />
          <Route path="/cn/other-products" element={<OtherProducts />} />
          <Route path="/cn/solutions/:sectionId/:subsectionId" element={<SubsectionPage />} />
          <Route path="/cn/solutions/:sectionId" element={<SectionPage />} />
        </Routes>
      </MainContent>
      <Breadcrumbs />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <LocaleProvider>
        <ScrollToTop />
        <AppContent />
      </LocaleProvider>
    </Router>
  );
}

export default App;
